<template>
  <v-radio-group v-model="selectedValue" :disabled="disabled" @change="changeSelected" class="radio-details">
    <template v-for="(option, index) in options" >
      <div v-if="option.visible !== false" :key="index">
        <v-radio class="styled-radio" :label="option.text" :value="option.value" />
        <slot v-if="option.value === selectedValue || !detailSelectionOnly" :name="'details' + index"></slot>
      </div>
			
    </template>
  </v-radio-group>
</template>
<script>
export default {
  name: "radioDetails",
  props: {
		value: {
      Required: true
    },
		options: {
			Type: Array,
			Required: true
    },
    disabled: Boolean,
    detailSelectionOnly: Boolean
  },
	components: {
  },
  created() {
    this.selectedValue = this.value
    const visibleOptions = this.options.filter(o => o.visible !== false)
    if(visibleOptions.length == 1){
      this. selectedValue = visibleOptions[0].value
      this.changeSelected(this.selectedValue)
    }
  },
  data() {
	  return {
      selectedValue: ''
	  }
  },
  methods: {
    changeSelected(newValue){
      this.$emit('change', newValue)
    }
  }
};
</script>
<style lang="scss">
.radio-details {
	width: 100%;

	.v-input__control {
		width: 100%;
	}

	&__details {
		width: 100%;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/layout/RadioDetails.vue